const NOTIFICATION_TYPES = [
  {
    id: 'email_facilitator_board_summaries',
    description: 'A meeting has changes and a summary is ready to download'
  },
]

export default NOTIFICATION_TYPES
